import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App, { SentryRoutes } from "./app";
import "./assets/stylesheets/index.css";
import { BrowserRouter, Navigate, Route } from "react-router";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [],
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <SentryRoutes>
      <Route path="/" element={<Navigate to={"/nl"} />} />
      <Route path="/nl/*" element={<App locale="nl" />} />
      <Route path="/fr/*" element={<App locale="fr" />} />
    </SentryRoutes>
  </BrowserRouter>,
);
